import * as React from "react";
import { forwardRef } from "react";
const SvgToolLength = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M2.12891 14.9263L9.26962 21.927" stroke="#CCCCCC" strokeWidth={2} strokeLinecap="round" /><path d="M14.7305 2.073L21.8712 9.07373" stroke="#CCCCCC" strokeWidth={2} strokeLinecap="round" /><line x1={18.301} y1={5.57336} x2={5.69966} y2={18.4266} stroke="#CCCCCC" strokeWidth={2} /></svg>;
const ForwardRef = forwardRef(SvgToolLength);
export { ForwardRef as ReactComponent };